// import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, useRouter, useState, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('RV');
    const [source, setSource] = useState('https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717080395416/4.mp4');

    const IMG = {
        '4': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075486935/4.jpg',
        '4_M': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075517414/4_M.jpg',
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setSource(window.innerWidth > 1024 ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717080395416/4.mp4' : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717080457689/4_M.mp4');
        }
    }, []);

    return (
        <div id="RV-D" className={`RV-D RV-box ${css['RV-D']}`}>
            <div className="img-box">
                {/* <EFPicture
                    src={'/responsive/picture/RV/4.jpg'}
                    srcPad={'/responsive/picture/RV/4_M.jpg'}
                    srcMobile={'/responsive/picture/RV/4_M.jpg'}
                    alt={t('D_bigTitle')}
                /> */}
                <video
                    src={source}
                    poster={IMG[source]}
                    className="video"
                    muted
                    loop
                    autoPlay
                    playsInline
                    preload="auto"
                    width="100%"
                    height="100%"
                ></video>
                <div className="info-box">
                    <p className="big-title">
                        {t.rich('D_bigTitle', {
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <p className="title">
                        {t.rich('D_title', {
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
}
